import React from 'react';
import { Download, Headphones, Zap } from 'lucide-react';
export function HowItWorks() {
  return <section className="bg-white py-16 px-4 border-y border-gray-200" data-id="element-110">
      <div className="max-w-4xl mx-auto" data-id="element-111">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-navy mb-12" data-id="element-112">
          How It Works
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-113">
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-gray-200 z-0" data-id="element-114"></div>

          <div className="relative z-10 flex flex-col items-center text-center" data-id="element-115">
            <div className="w-24 h-24 bg-navy rounded-full flex items-center justify-center text-white mb-6 shadow-lg border-4 border-white" data-id="element-116">
              <Download size={36} data-id="element-117" />
            </div>
            <h3 className="text-xl font-bold text-navy mb-2" data-id="element-118">
              1. Instant Access
            </h3>
            <p className="text-gray-600" data-id="element-119">
              Secure your bundle and receive a download link immediately via
              email.
            </p>
          </div>

          <div className="relative z-10 flex flex-col items-center text-center" data-id="element-120">
            <div className="w-24 h-24 bg-patriot-red rounded-full flex items-center justify-center text-white mb-6 shadow-lg border-4 border-white" data-id="element-121">
              <Headphones size={36} data-id="element-122" />
            </div>
            <h3 className="text-xl font-bold text-navy mb-2" data-id="element-123">
              2. Listen & Read
            </h3>
            <p className="text-gray-600" data-id="element-124">
              Experience the audiobook and dive into the digital bonus guides on
              any device.
            </p>
          </div>

          <div className="relative z-10 flex flex-col items-center text-center" data-id="element-125">
            <div className="w-24 h-24 bg-gold rounded-full flex items-center justify-center text-navy mb-6 shadow-lg border-4 border-white" data-id="element-126">
              <Zap size={36} data-id="element-127" />
            </div>
            <h3 className="text-xl font-bold text-navy mb-2" data-id="element-128">3. Take Action</h3>
            <p className="text-gray-600" data-id="element-129">
              Use the strategies provided to strengthen your community and
              family today.
            </p>
          </div>
        </div>
      </div>
    </section>;
}